import { useQuery } from "react-query";
import { getTelentCategories } from "services/talentCategories.service";

export default function useTalentCategories() {
  return useQuery("talentCategories", async () => await getTelentCategories());
}
